import { PoweredByFooter } from 'components/pages/common'
import styled from 'styled-components'

export const PoweredByFooterStyled = styled(PoweredByFooter)`
  margin-top: 16px;
`
